import {
  BefundItem,
  BehandlungItem,
  DiagnoseItem,
  ExtractedFragebogenData,
} from '../../models/interfaces';
import { ExtractedDocumentDataSnapshot } from '../app-state/persist-data.service';
import { formatDate } from '../../utils/Date.utils';

export function mapToFragebogenData(
  snapshot: ExtractedDocumentDataSnapshot,
): ExtractedFragebogenData {
  const befunde: BefundItem[] =
    snapshot.tables['page2_befunde']?.map((row) => ({
      art: row.rowData['page2_befunde_art'].value as string,
      beschreibung: row.rowData['page2_befunde_beschreibung'].value as string,
    })) ?? [];

  const diagnosen: DiagnoseItem[] =
    snapshot.tables['page2_diagnosen']?.map((row) => ({
      icd10Code: row.rowData['page2_diagnosen_icd10_code'].value as string,
      klartext: row.rowData['page2_diagnosen_klartext'].value as string,
    })) ?? [];

  const behandlungen: BehandlungItem[] =
    snapshot.tables['page2_behandlung']?.map((row) => ({
      art: row.rowData['page2_behandlung_art'].value as string,
      datum: formatDate(row.rowData['page2_behandlung_datum'].value as string) ?? '',
      beschreibung: row.rowData['page2_behandlung_beschreibung'].value as string,
    })) ?? [];

  const unfallunabhaengigeDiagnosen: DiagnoseItem[] =
    snapshot.tables['page4_unfallunabhaengige_diagnosen']?.map((row) => ({
      icd10Code: row.rowData['page4_unfallunabhaengige_diagnosen_icd10_code'].value as string,
      klartext: row.rowData['page4_unfallunabhaengige_diagnosen_klartext'].value as string,
    })) ?? [];

  const bewusstseinsstoerungen: string[] = [];
  const auswahl = snapshot.fields['page4_bewusstseinsstoerung_auswahl'];
  const andere = snapshot.fields['page4_bewusstseinsstoerung_andere'];
  if (auswahl) {
    bewusstseinsstoerungen.push(auswahl as string);
  }
  if (andere) {
    bewusstseinsstoerungen.push(andere as string);
  }

  return {
    behandlungVon: formatDate(snapshot.fields['page1_behandlung_von'] as string) ?? '',
    behandlungBis: formatDate(snapshot.fields['page1_behandlung_bis'] as string) ?? '',
    behandlungstyp: snapshot.fields['page1_behandlungstyp'] as string,
    unfallhergang: snapshot.fields['page1_unfallhergang'] as string,
    beschwerden: snapshot.fields['page1_beschwerden'] as string,
    beschwerdenAufgetretenAm:
      formatDate(snapshot.fields['page1_beschwerden_aufgetreten_am'] as string) ?? '',
    arbeitsunfaehigkeitVon:
      formatDate(snapshot.fields['page1_arbeitsunfaehigkeit_von'] as string) ?? '',
    arbeitsunfaehigkeitBis:
      formatDate(snapshot.fields['page1_arbeitsunfaehigkeit_bis'] as string) ?? '',
    beruf: snapshot.fields['page1_beruf'] as string,
    kostentraeger: snapshot.fields['page1_kostentraeger'] as string,
    kostentraegerName: snapshot.fields['page1_name_des_kostentraegers'] as string,
    gdb: snapshot.fields['page1_gdb'] as string,
    merkzeichen: snapshot.fields['page1_merkzeichen'] as string,
    mde: snapshot.fields['page1_mde'] as number,
    pflegegrad: snapshot.fields['page1_pflegegrad'] as string,
    befunde,
    diagnosen,
    behandlungen,
    hinzugezogenVorname: snapshot.fields['page2_hinzugezogen_vorname'] as string,
    hinzugezogenNachname: snapshot.fields['page2_hinzugezogen_nachname'] as string,
    hinzugezogenFachrichtung: snapshot.fields['page2_hinzugezogen_fachrichtung'] as string,
    hinzugezogenStrassehausnummer: snapshot.fields['page2_strassehausnummer'] as string,
    hinzugezogenPlz: snapshot.fields['page2_hinzugezogen_plz'] as string,
    hinzugezogenOrt: snapshot.fields['page2_hinzugezogen_ort'] as string,
    weiterhinInBehandlung: snapshot.fields['page3_weiterhin_in_behandlung'] === 'Ja',
    weiterbehandlerEinrichtung: snapshot.fields['page3_weiterbehandler_einrichtung'] as string,
    weiterbehandlerVorname: snapshot.fields['page3_weiterbehandler_vorname'] as string,
    weiterbehandlerNachname: snapshot.fields['page3_weiterbehandler_nachname'] as string,
    weiterbehandlerStrassehausnummer: snapshot.fields[
      'page3_weiterbehandler_strassehausnummer'
    ] as string,
    weiterbehandlerPlz: snapshot.fields['page3_weiterbehandler_plz'] as string,
    weiterbehandlerOrt: snapshot.fields['page3_weiterbehandler_ort'] as string,
    weitereBehandlungsdauer: snapshot.fields['page3_weitere_behandlungsdauer'] as string,
    datumLetzteKonsultation:
      formatDate(snapshot.fields['page3_datum_letzte_konsultation'] as string) ?? '',
    befundLetzteKonsultation: snapshot.fields['page3_befund_letzte_konsultation'] as string,
    stoerungenImHeilverlauf: snapshot.fields['page3_stoerungen_im_heilverlauf'] as string,
    koerperlicheGeistigeEinschraenkungen: snapshot.fields[
      'page3_koerperliche_geistige_einschraenkungen'
    ] as string,
    besserungsmassnahmen: snapshot.fields['page3_besserungsmassnahmen'] as string,
    fachrichtungZweitmeinung: snapshot.fields['page3_fachrichtung_zweitmeinung'] as string,
    bewertungsnoten: snapshot.fields['page4_bewertungsnoten'] as string,
    langfristigeFolgen: snapshot.fields['page4_langfristige_folgen'] as string,
    datumAbschaetzungLangfristigeFolgen:
      formatDate(snapshot.fields['page4_datum_abschaetzung_langfristige_folgen'] as string) ?? '',
    unfallunabhaengigeDiagnosen,
    bewusstseinsstoerungen,
  };
}
